import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Text from '../_primitives/text/text.esm.js';

var _excluded = ["children"];
var Expander = function Expander(props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: "a",
    variant: 'ellipsisExpand',
    lhCrop: "text-container-expander"
  }, rest), children);
};

export default Expander;
//# sourceMappingURL=expander.esm.js.map
